
import { mapActions } from 'vuex';
import LIKE from './LIKE';
import FOLLOW from './FOLLOW';
import REPOST from './REPOST';
import REPLY from './REPLY';
import MENTION from './MENTION';
import PORTFOLIOLIKE from './PORTFOLIOLIKE';
import PORTFOLIOCOMMENT from './PORTFOLIOCOMMENT';
import PORTFOLIOFAVORITE from './PORTFOLIOFAVORITE';
import PRICECHANGE from './PRICECHANGE';
import ADDEDTOPORTFOLIO from './ADDEDTOPORTFOLIO';
import PORTFOLIOACTION from './PORTFOLIOACTION';
import PORTFOLIOREPOST from './PORTFOLIOREPOST';
import LEAGUEINVITE from './LEAGUEINVITE';
import PRIVATEMESSAGE from './PRIVATEMESSAGE';
import ORDERCOMPLETED from './ORDERCOMPLETED.vue';
import MoreIcon from '~/components/ui/icons/MoreIcon.vue';
import { inAppRedirect, appURLs } from '~/utils/route-redirects';
import DeleteTrashIcon from '~/components/ui/icons/DeleteTrashIcon.vue';
import CheckIcon from '~/components/ui/icons/CheckIcon.vue';
import { isMobile } from '~/utils/screenSizes';
import { isMobileResponsive } from '~/utils/mixins';
import LEAGUERANKCHANGE from './LEAGUERANKCHANGE.vue';
import LeagueImg from '~/components/ui/atom/LeagueImg.vue';
import { NotificationTypes } from '~/utils/constants/notificationTypes';

export default {
  name: 'NotifItem',
  components: {
    LIKE,
    FOLLOW,
    REPOST,
    REPLY,
    MENTION,
    PORTFOLIOLIKE,
    PORTFOLIOCOMMENT,
    PORTFOLIOFAVORITE,
    PRICECHANGE,
    ADDEDTOPORTFOLIO,
    PORTFOLIOREPOST,
    PORTFOLIOACTION,
    LEAGUEINVITE,
    LEAGUERANKCHANGE,
    PRIVATEMESSAGE,
    ORDERCOMPLETED,
    MoreIcon,
    DeleteTrashIcon,
    CheckIcon,
    LeagueImg,
  },
  mixins: [isMobileResponsive],
  props: {
    notif: {
      required: true,
      type: Object,
    },
    last: {
      type: Boolean,
      dafault: false,
    },
    isNotificationCenter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showDrawer: false,
    };
  },
  computed: {
    isMobileSize() {
      return isMobile();
    },
    cardBorderClasses() {
      let res = '';

      if (this.notif.read) {
        res += 'bg-neutral-1';
      } else {
        res += 'bg-primary-2';
      }

      if (this.isNotificationCenter && !this.isMobileResponsive) {
        res += ' border border-neutral-4 rounded-lg p-4';
      } else {
        res += ' py-2.5 pr-2 pl-1.5';
      }

      return res;
    },
    isLeagueRankChange() {
      return this.notif.type === NotificationTypes.LEAGUERANKCHANGE;
    },
    isOrderNotification() {
      return this.notif.type === NotificationTypes.ORDERCOMPLETED;
    },
    isLeagueViolationRuleNotif() {
      return this.notif.type === NotificationTypes.LEAGUERULEVIOLATION;
    },
    // League rank change and rule violation notifications show a league image instead of an author's profile image.
    displayProfileImg() {
      return !this.isLeagueRankChange && !this.isLeagueViolationRuleNotif;
    },
    // League rank change and order notifications are system-generated, not authored by a user, so there's no name to show.
    displayAuthorName() {
      return !this.isLeagueRankChange && !this.isOrderNotification;
    },
  },
  methods: {
    ...mapActions('notifications', [
      'removeNotification',
      'toggleNotificationRead',
    ]),
    goToProfile(profileId) {
      inAppRedirect(`/profile/${profileId}`);
    },
    handleDeleteNotification(notificationId) {
      this.removeNotification({ id: notificationId });
    },
    goToLeague(item) {
      inAppRedirect(appURLs.leagueById(item.leagueId));
    },
  },
};
